import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryReactMouse } from './EventRegistryReactMouse';
import { EventRegistryReactAnimation } from './EventRegistryReactAnimation';
import { EventRegistryReactClipboard } from './EventRegistryReactClipboard';
import { EventRegistryReactComposition } from './EventRegistryReactComposition';
import { EventRegistryReactFocus } from './EventRegistryReactFocus';
import { EventRegistryReactTransition } from './EventRegistryReactTransition';
import { EventRegistryReactTouch } from './EventRegistryReactTouch';
import { EventRegistryReactKeyboard } from './EventRegistryReactKeyboard';
import { EventRegistryReactSelection } from './EventRegistryReactSelection';
import { EventRegistryReactForm } from './EventRegistryReactForm';
import { EventRegistryReactMedia } from './EventRegistryReactMedia';
import { EventRegistryReactUI } from './EventRegistryReactUI';
export class EventRegistryReact extends EventRegistryCategory {
    label = 'React';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_a = new EventRegistryReactAnimation(this);
    c_c = new EventRegistryReactClipboard(this);
    c_co = new EventRegistryReactComposition(this);
    c_f = new EventRegistryReactFocus(this);
    c_fo = new EventRegistryReactForm(this);
    c_k = new EventRegistryReactKeyboard(this);
    c_m = new EventRegistryReactMedia(this);
    c_mo = new EventRegistryReactMouse(this);
    c_s = new EventRegistryReactSelection(this);
    c_t = new EventRegistryReactTouch(this);
    c_tr = new EventRegistryReactTransition(this);
    c_u = new EventRegistryReactUI(this);
}
